<template>
	<div class="footer">
		<div class="homebottom">
			<div class="goLinks">
				<div><a href="/">首页</a></div>
				<span>|</span>
				<div>
					<a
						href="/special?pid=1828310500999577601&menuId=1828311656236728321"
						>新闻动态</a
					>
				</div>
				<span>|</span>
				<div>
					<a
						href="/special?pid=1828310633946431489&menuId=1828312264729575425"
						>发展研究</a
					>
				</div>
				<span>|</span>
				<div>
					<a
						href="/special?pid=1828310733133332482&menuId=1828313714331369473"
						>知识交流</a
					>
				</div>
				<span>|</span>
				<div>
					<a
						href="/special?pid=1828310842516586497&menuId=1828606915286024194"
						>知识产品</a
					>
				</div>
				<span>|</span>
				<div>
					<a href="http://www.gsrc-web.net/cn" target="_blank"
						>全球南方研究中心</a
					>
				</div>
				<span>|</span>
				<div>
					<a
						href="/aboutus?pid=1828311428746067970&menuId=1838387784930443265"
						>关于我们</a
					>
				</div>
			</div>
			<div data-v-d3d9e58e="" class="footer-underbox">
				<div class="leftContent">
					<span data-v-d3d9e58e="" class="span1"
						>版权所有&nbsp;&nbsp; 中国国际发展知识中心&nbsp;&nbsp;
						京ICP备17048856号&nbsp;&nbsp;&nbsp;&nbsp;</span
					>
					<span data-v-d3d9e58e="" class="span1"
						>京公网安备
						11030102010789号&nbsp;&nbsp;&nbsp;&nbsp;</span
					>
				</div>
				<div class="header-underbox-share-box">
					<!-- 两种调用方式都行 -->
					<!-- <div class="social-share" data-sites="wechat,twitter,linkedin,weibo"></div>   -->
					<div class="social-share" data-initialized="true">
						<a
							href="javascript:void(0);"
							class="social-share-icon icon-wechat"
							style="position: relative"
						>
							<img
								src="../../assets/imgs/wechat.png"
								alt="微信"
							/>
							<!-- <img
								v-if="!shareHover.hover1"
								src="../../assets/imgs/wechat_hover.png"
								alt="微信"
							/> -->
							<div
								class="wechat_showbox"
								v-if="!shareHover.hover1"
							>
								<img
									src="../../assets/imgs/cikd_wechat.jpg"
									alt="微信"
								/>
							</div>
						</a>
						<a
							href="https://twitter.com/CIKD_org"
							target="_blank"
							class="social-share-icon icon-twitter"
						>
							<img
								v-if="shareHover.hover2"
								src="../../assets/imgs/twitter.png"
								alt="推特"
							/>
							<img
								v-if="!shareHover.hover2"
								src="../../assets/imgs/twitter_hover.png"
								alt="推特"
							/>
						</a>
						<a
							href="https://www.linkedin.com/company/cikd/about/"
							target="_blank"
							class="social-share-icon icon-linkedin"
						>
							<img
								v-if="shareHover.hover3"
								src="../../assets/imgs/linkedin.png"
								alt="领英"
							/>
							<img
								v-if="!shareHover.hover3"
								src="../../assets/imgs/linkedin_hover.png"
								alt="领英"
							/>
						</a>
						<a
							href="https://weibo.com/p/1001066451429540"
							target="_blank"
							class="social-share-icon icon-weibo"
						>
							<img
								v-if="shareHover.hover4"
								src="../../assets/imgs/wb.png"
								alt="微博"
							/>
							<img
								v-if="!shareHover.hover4"
								src="../../assets/imgs/wb_hover.png"
								alt="微博"
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {
			newYear: new Date().getFullYear(),
			shareHover: {
				hover1: true,
				hover2: true,
				hover3: true,
				hover4: true,
			},
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.shareFn();
	},
	methods: {
		//分享函数
		shareFn() {
			//hover效果
			$('.social-share .icon-wechat').off('mouseenter');
			$('.social-share .icon-wechat').on('mouseenter', () => {
				this.shareHover.hover1 = false;
			});
			$('.social-share .icon-wechat').off('mouseleave');
			$('.social-share .icon-wechat').on('mouseleave', () => {
				this.shareHover.hover1 = true;
			});

			// $('.social-share .icon-twitter').off('mouseenter');
			// $('.social-share .icon-twitter').on('mouseenter', () => {
			// 	this.shareHover.hover2 = false;
			// });
			// $('.social-share .icon-twitter').off('mouseleave');
			// $('.social-share .icon-twitter').on('mouseleave', () => {
			// 	this.shareHover.hover2 = true;
			// });

			// $('.social-share .icon-linkedin').off('mouseenter');
			// $('.social-share .icon-linkedin').on('mouseenter', () => {
			// 	this.shareHover.hover3 = false;
			// });
			// $('.social-share .icon-linkedin').off('mouseleave');
			// $('.social-share .icon-linkedin').on('mouseleave', () => {
			// 	this.shareHover.hover3 = true;
			// });

			// $('.social-share .icon-weibo').off('mouseenter');
			// $('.social-share .icon-weibo').on('mouseenter', () => {
			// 	this.shareHover.hover4 = false;
			// });
			// $('.social-share .icon-weibo').off('mouseleave');
			// $('.social-share .icon-weibo').on('mouseleave', () => {
			// 	this.shareHover.hover4 = true;
			// });

			var config = {
				url: window.location.href, // 网址，默认使用 window.location.href
				source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
				title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
				description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
				image: '', // 图片, 默认取网页中第一个img标签
				sites: ['wechat', 'twitter', 'linkedin', 'weibo'], // 启用的站点
				disabled: [], // 禁用的站点
				wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
				wechatQrcodeHelper: '',
				target: '_blank', //打开方式
			};
			// socialShare('.social-share',config);
		},
	},
};
</script>
<style lang="less" scoped>
.goLinks {
	display: flex;
	justify-content: center;
	// margin-right: 210px;
	span {
		margin: 0 10px;
	}
}
.footer {
	border-top: 9px solid #0072b5;
	min-width: 1200px;
	background: #ffffff;
	padding: 0;
	letter-spacing: 0.2px;
}
.footer-underbox {
	display: flex;
	justify-content: center;
	height: 50px;
	align-items: center;
	.leftContent {
		width: 100%;
		text-align: center;
		padding-left: 168px;
	}
	.header-underbox-share-box {
		width: 211px;
		height: 50px;
		line-height: 50px;
		// background: rgba(42, 95, 170, 1);
		.social-share {
			display: flex;
			justify-content: space-evenly;
			// img {
			// 	width: 18px;
			// 	height: 18px;
			// 	max-width: 18px;
			// 	max-height: 18px;
			// 	min-width: 18px;
			// 	min-height: 18px;
			// }
		}
	}
}
.homebottom {
	max-width: 1366px;
	// padding-top: 20px;
	margin: 30px auto 40px auto;
	color: #6e6f71;
	font-size: 16px;
	line-height: 28px;
}

.homebottom a {
	color: #6e6f71;
	// font-size: 14px;
}

// .homebottom td a {
// 	text-decoration: underline;
// 	font-size: 12px;
// }
.beian_a {
	background: url('@/assets/imgs/footer/filingForTheRecord.png') left center
		no-repeat;
	background-repeat: no-repeat;
	display: inline-block;
	text-decoration: none;
}
.wechat_showbox {
	position: absolute;
	top: -160px;
	z-index: 500;
	width: 10rem;
	margin-bottom: 1rem;
	border: 0 solid #fff;
	-webkit-transform: translateX(-50%);
	transform: translateX(-50%);
	box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
	/* display: none; */
}
.wechat_showbox img {
	display: block;
	width: 100%;
}
@media screen and (max-width: 769px) {
	.footer {
		min-width: 0;
		padding: 24px;
	}
	.homebottom table {
		width: 100%;
	}
}
</style>
